/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useRef, useState } from "react";
import * as ReactDOMServer from "react-dom/server";
import { useDispatch, useSelector } from "react-redux";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import axios from "axios";
import CustomLayout from "../../Core/Layout/CustomLayout";
import CustomMapMarker from "../../Core/Components/CustomMapMarker";
import TrikeMapMarkerDetails, {
  MapDetailDrawer,
  OtherMapMarkerDetails,
} from "../../Core/Components/CustomMapMarkerDetails";
import { getAllTrikesV3, getChecklist } from "../../Redux/APIs/trikesAPI";
import { getAllBatteriesV3 } from "../../Redux/APIs/batteriesAPI";
import {
  getAllHubs,
  getAllLocationsV3,
  getGlobalLocations,
} from "../../Redux/APIs/locationsAPI";
import getColorAndIcon from "../../Core/utils/getColorAndIcon";
import {
  getAllSystemUsers,
  getMetaData,
  getUserByEmail,
} from "../../Redux/APIs/systemUsersAPI";
import { updateLoggedInUser } from "../../Redux/Slices/loggedInUser.slice";
import { getAllCountKpi, getHomeKpi } from "../../Redux/APIs/homeAPI";
import { updateTrikes } from "../../Redux/Slices/trikes.slice";
import MobiliseModalV3 from "../../Core/Components/Modal/MobiliseModalV3";
import { TRIKE_STATUS } from "../Trikes/Data";
import { INITIAL_ZOOM_LEVEL, MAX_BOUNDS } from "./Data/HomeData";
import NoHubStationModal from "./NoHubStationModal";
import { updateHome } from "../../Redux/Slices/home.slice";
import {
  getAllAssets,
  getPowerAfricaAssetChecklist,
} from "../../Redux/APIs/powerAfricaAPI";
import { getAllDrivers } from "../../Redux/APIs/usersAPI";
import ProductKPIs from "./ProductKPIs";
import TrikeListings from "./TrikeListings";
import { client } from "../../Utils/axiosClient";
import Button from "../../Core/Components/CustomButton";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import ModuleKPIs from "./ModuleKPIs";
import {
  DEFAULT_LAT,
  DEFAULT_LONG,
  TENANT_PERMISSIONS,
} from "../Login/constants";
import { useTenantPermission } from "../../Core/hooks/usePermission";
import useMapMarkerHeaders from "./Data/useMapMarkerHeaders";

const Home = () => {
  const dispatch = useDispatch();

  const { locationDetails, userDetails } = useSelector(
    (state) => state.loggedInUser,
  );
  const { mobiliseModalV3 } = useSelector((state) => state.trikes);

  const { noHubStationModal } = useSelector((state) => state.home);

  const [showListingsAndKPI, setShowListingsAndKPI] = useState(true);
  const [locationsLoading, setLocationsLoading] = useState(false);
  const [filterMarkers, setFilterMarkers] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);

  const mapRef = useRef(null);
  const myRef = useRef([]);

  // to show the trike listings section or no
  const hasTrikePermission = useTenantPermission([
    TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
  ]);

  const renderCustomIcon = (type, trike = {}) => {
    const { colors, icon, topIcon } = getColorAndIcon(type);
    // eslint-disable-next-line new-cap
    return new L.divIcon({
      html: ReactDOMServer.renderToString(
        <CustomMapMarker
          position="map"
          icon={icon}
          topIcon={
            trike?.status == TRIKE_STATUS.ON_TRIP ||
            trike?.status == TRIKE_STATUS.OUT_OF_GEOFENCE
              ? topIcon
              : null
          }
          colors={colors}
        />,
      ),
    });
  };

  const getAssetLatLngs = () => {
    const baseLat = parseFloat(userDetails?.baseLat || DEFAULT_LAT);
    const baseLong = parseFloat(userDetails?.baseLong || DEFAULT_LONG);

    return [baseLat, baseLong];
  };

  const getWeatherInformation = useCallback(async () => {
    try {
      if (lat && long) {
        const result = await axios.get(
          "https://api.openweathermap.org/data/2.5/weather",
          {
            params: {
              lat,
              lon: long,
              appid: process.env.REACT_APP_WEATHER_API_KEY,
              units: "metric",
            },
          },
        );

        const temperature = result?.data?.main?.temp;
        const city = result?.data?.name;
        const countryCode = result?.data?.sys?.country;
        const sunset = result?.data?.sys?.sunset;

        dispatch(
          updateLoggedInUser({
            key: "locationDetails",
            value: {
              ...locationDetails,
              temperature,
              city,
              countryCode,
              sunset,
            },
          }),
        );
      }
    } catch (err) {
      console.log(err, "Error in fetching the weather");
    }
  }, [dispatch, lat, long]);

  const assignRefsForMarkers = (ref, item) => {
    if (item.type === "5") {
      myRef[item.id] = ref;
    } else {
      myRef[item.name] = ref;
    }
  };

  const handleFilters = (id) => {
    if (filterMarkers.includes(id)) {
      setFilterMarkers(filterMarkers?.filter((item) => item !== id));
    } else {
      setFilterMarkers([...filterMarkers, id]);
    }
  };

  useEffect(() => {
    getWeatherInformation(lat, long);
  }, [getWeatherInformation]);

  useEffect(() => {
    const getCoordinates = () => {
      navigator.geolocation.getCurrentPosition((position) => {
        setLat(position?.coords?.latitude);
        setLong(position?.coords?.longitude);
      });
    };

    getCoordinates();

    const fetchData = async () => {
      dispatch(getMetaData());
      dispatch(getHomeKpi());
      dispatch(getAllCountKpi());
      dispatch(getAllTrikesV3());
      dispatch(getUserByEmail({ email: userDetails.email }));

      setTimeout(() => {
        dispatch(getAllBatteriesV3());
        dispatch(getAllLocationsV3());
        dispatch(getGlobalLocations());
        dispatch(getAllHubs());
      }, 1000);

      setTimeout(() => {
        dispatch(getChecklist());
        dispatch(getAllSystemUsers());
        dispatch(getAllAssets());
        dispatch(getPowerAfricaAssetChecklist());
        dispatch(getAllDrivers());
      }, 1500);

      // update the settings tab
      dispatch(
        updateLoggedInUser({
          key: "settingsTab",
          value: "general",
        }),
      );
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const fetchHomeFilters = async () => {
      try {
        setLocationsLoading(true);

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/home/home-filters`,
          {
            params: {
              filters: filterMarkers,
            },
          },
        );

        setFilteredLocations(response.data?.filteredLocations);
      } catch (err) {
        console.log(err);
      } finally {
        setLocationsLoading(false);
      }
    };

    fetchHomeFilters();
  }, [filterMarkers]);

  console.log(userDetails, "check logged in user");

  return (
    <CustomLayout pageName="Home" hideFooter>
      <div className="w-full h-full">
        <div className="relative w-full h-full">
          <div className="absolute z-20 flex flex-col p-6">
            {/* dependent on tenant permissions */}
            <ProductKPIs showListingsAndKPI={showListingsAndKPI} />

            {/* dependent on user permissions */}
            <ModuleKPIs />
          </div>

          {/* trike listings */}
          {hasTrikePermission && (
            <div
              className={`absolute z-40 left-[24px] w-[23.5%] 2xl:w-[23.9%] transform transition-all duration-200
             ${
               showListingsAndKPI
                 ? "top-[calc(24px+92px+48px+12px+24px)] h-[calc(100vh-72px-24px-12px-92px-12px-12px-60px)]"
                 : "top-[calc(48px+12px+24px)] h-[calc(100vh-12px-60px-24px-80px)]"
             }
            `}
            >
              <TrikeListings mapRef={mapRef} />
            </div>
          )}

          {/* map marker buttons */}
          <div
            className={`absolute z-40 max-h-10 w-[72.6%] transform transition-all duration-200
             ${
               showListingsAndKPI
                 ? "top-[calc(24px+92px+48px+12px+24px)]"
                 : "top-[calc(48px+12px+24px)]"
             }
             ${hasTrikePermission ? "left-[26%]" : "left-[24px]"}
            `}
          >
            <div>
              <div className="flex gap-x-3">
                {useMapMarkerHeaders()
                  .filter((m) => m.hasPermission)
                  .map((item) => (
                    <Button
                      key={item.id}
                      width="dynamic"
                      size="maps"
                      padding="mapMarkers"
                      colors={
                        filterMarkers.includes(item.id) ? "primary" : "white"
                      }
                      modifier="shadow"
                      onClick={() => handleFilters(item.id)}
                    >
                      <div className="flex gap-x-2">
                        <div>{item.title}</div>
                        {filterMarkers.includes(item.id) ? (
                          <CloseIcon className="w-4 h-4 stroke-white" />
                        ) : null}
                      </div>
                    </Button>
                  ))}
              </div>
            </div>
          </div>

          {/* show-hide KPI button */}
          <div
            className={`absolute z-40 right-6 transform transition-all duration-200
            ${
              showListingsAndKPI
                ? "top-[calc(24px+92px+48px+12px+24px)]"
                : "top-[calc(48px+12px+24px)]"
            }
            `}
          >
            <div
              role="button"
              className="h-8 p-2 bg-white text-dark-grey-text shadow-button rounded-md"
              onClick={() => setShowListingsAndKPI((prev) => !prev)}
            >
              <img
                src={
                  showListingsAndKPI
                    ? "/assets/minimize.svg"
                    : "/assets/maximize.svg"
                }
                className="w-4 h-4"
                alt=""
              />
            </div>
          </div>

          <MapContainer
            center={getAssetLatLngs()}
            zoom={INITIAL_ZOOM_LEVEL}
            maxBounds={MAX_BOUNDS}
            zoomControl={false}
            className="z-10 w-full h-full"
            ref={mapRef}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              minZoom={3}
              maxZoom={17}
            />

            {/* mapping all the trikes, farms and other locations on the map */}
            {!locationsLoading &&
              filteredLocations?.map((item, index) => {
                return (
                  <div key={index + 1}>
                    {/* mapping the items based on the type, 5 represents trike */}
                    {item.type === "5" ? (
                      <div>
                        {/* if the location for the trike is not available, we do not show it on the map */}
                        {item?.locationLat == 0 && item?.locationLong == 0 ? (
                          <div />
                        ) : (
                          <Marker
                            ref={(el) => assignRefsForMarkers(el, item)}
                            position={[item?.locationLat, item?.locationLong]}
                            icon={renderCustomIcon(item?.type, item)}
                          >
                            {/* trike popup with relevant trike details */}
                            <Popup>
                              <TrikeMapMarkerDetails
                                assetId={item.registrationNo}
                                trikeDetail={item}
                              />
                            </Popup>
                          </Marker>
                        )}
                      </div>
                    ) : (
                      // marker for the items other than trike
                      <Marker
                        ref={(el) => assignRefsForMarkers(el, item)}
                        position={[item?.lat, item?.long]}
                        icon={renderCustomIcon(item?.type)}
                      >
                        <Popup>
                          <OtherMapMarkerDetails item={item} />
                        </Popup>
                      </Marker>
                    )}
                  </div>
                );
              })}
          </MapContainer>

          <div className="z-20">
            <MapDetailDrawer
              mapRef={mapRef}
              initialZoomLevel={INITIAL_ZOOM_LEVEL}
              center={getAssetLatLngs()}
              getColorAndIcon={getColorAndIcon}
            />
          </div>
        </div>
      </div>

      <MobiliseModalV3
        visible={mobiliseModalV3?.visible}
        onCancel={() =>
          dispatch(
            updateTrikes({
              key: "mobiliseModalV3",
              value: {
                visibe: false,
                trike: {},
              },
            }),
          )
        }
      />

      <NoHubStationModal
        visible={noHubStationModal}
        onCancel={() =>
          dispatch(updateHome({ key: "noHubStationModal", value: false }))
        }
      />
    </CustomLayout>
  );
};

export default Home;
